import { z } from 'zod';
import { SalesOrderShortfallResolution } from '../../constants/sales-order-shortfall-resolution.js';
import { requiredUuidString } from '../zod-helpers/index.js';
import { shipShortfallChoiceInputSchema } from './ship-shortfall-choice-input.js';
const shortfallRowSchema = z
    .object({
    salesOrderItemId: requiredUuidString('Line is required.', 'Invalid line selection.'),
    savedResolutionId: z.enum(SalesOrderShortfallResolution).nullable(),
    resolutionId: z.enum(SalesOrderShortfallResolution).nullable(),
})
    .superRefine((row, context) => {
    const result = shipShortfallChoiceInputSchema.shape.resolutionId.safeParse(row.resolutionId);
    const message = result.error?.issues[0]?.message;
    if (message)
        context.addIssue({ code: 'custom', path: ['resolutionId'], message });
});
/** The Shortfall step: one row per short line, preset with its saved choice (S-2). */
export const shipDialogShortfallStepSchema = z.array(shortfallRowSchema);
export const shipDialogFormSchema = z.object({ shortfall: shipDialogShortfallStepSchema });
//# sourceMappingURL=ship-dialog-form.js.map